import React, { useEffect } from 'react'
import styles from './styles.module.css'
import Button from '../../components/Button'
import { IoIosAdd } from 'react-icons/io'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import Modal from './Modal'
import Table from '../../components/Table'
import { BiTrash } from 'react-icons/bi'
import Confirmation from '../../components/Confirmation/Confirmation'
import { deleteFitnessIndicators, getFitnessIndicators } from '../../actions/fitnessIndicators'


export default function FitnessIndicators() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { fitnessIndicatorsList } = useSelector(state => state.fitnessIndicators)

  const [selectedItem, setSelectedItem] = useState(null)
  const [confirmation, setConfirmation] = useState(false);

  useEffect(() => {
    dispatch(getFitnessIndicators())
  }, [selectedItem])

  const openModal = (data) => () => {
    setSelectedItem(data)
  }

  const closeModal = () => setSelectedItem(null)

  const goHome = () => navigate('/')

  const acceptConfirmation = () => {
    closeModal();
    dispatch(deleteFitnessIndicators(confirmation.id));
    setConfirmation(false);
  };
  const rejectConfirmation = () => {
    setConfirmation(false);
  };

  const renderLi = (data) => {
    const { iid, iname } = data
    return (
      <tr >
        <td onClick={openModal(data)}>{iname}</td>
        <td><i className={styles.trash} onClick={() => setConfirmation({ id: iid, name: iname })}><BiTrash /></i></td>
      </tr>
    )
  }

  return (
    <div className={styles.wrapper} style={{ width: '700px', margin: '0 auto' }}>
      {confirmation && (
        <Confirmation
          top="30px"
          left="40px"
          title={`Вы уверены, что хотите удалить ${confirmation.name}?`}
          acceptConfirmation={() => acceptConfirmation(confirmation?.name)}
          rejectConfirmation={rejectConfirmation}
        />
      )}
      {selectedItem &&
        <Modal
          closeModal={closeModal}
          data={selectedItem}
          height={'430px'}
          // addMode={(!selectedItem?.name && selectedItem !== null)}
          addMode={selectedItem == 'add'}
        />
      }
      <h1>Показатели физической подготовки</h1>

      <Table className={styles.tableDis}>
        <thead>
          <tr>

            <th>Название</th>

            <th></th>
          </tr>
        </thead>
        <tbody>

          {fitnessIndicatorsList?.map(renderLi)}

        </tbody>
      </Table>

      <div style={{ display: 'flex', flexDirection: "row" }}>
        <Button
          style={{ padding: '.5rem 1.5rem', margin: '12px' }}
          onClick={openModal('add')}
        >
          <IoIosAdd size={30} />
          Добавить
        </Button>
      </div>
    </div>
  )
}
